import { Box, Card, Typography, styled } from '@mui/material';

export const DetailsBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '50%',
  margin: 'auto 0',
  padding: '0',
  wordWrap: 'break-word',
});

export const ContentDetailsBoxStyled = styled(Card)({
  display: 'flex',
  boxShadow: 'none',
  border: 'none',
  background: 'none',
}) as typeof Card;

export const ContentDetailsWrapperStyled = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
}));

export const ItemLabelStyled = styled(Typography)(({ theme }) => ({
  paddingRight: theme.spacing(5),
})) as typeof Typography;
